"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var imgRoot = "/img/common/konami/";
function Charizard() {
    var flyguy = document.createElement('img');
    flyguy.src = imgRoot + 'pocketmonster.png';
    flyguy.className = 'flyguy';
    document.body.appendChild(flyguy);
    setTimeout(function () {
        document.body.removeChild(flyguy);
    }, 5000);
}
exports.Charizard = Charizard;
